<section class="language-screen" data-cy="language-screen">

  <p class="lang-heading tw-text-[#000000]" data-cy="lang-heading">
    {{ 'account.preferences.language.languages' | translate: 'Languages' }}
  </p>

  <div class="lang-group">
    @for (language of languages; track language.code) {
      <button
        type="button"
        class="lang-row"
        [disabled]="isDisabled"
        (click)="setLanguage(language.code)"
        [attr.aria-pressed]="selectedLanguage === language.code"
        [attr.data-cy]="'lang-' + language.code"
      >
        <i
          class="lang-dot"
          [class.active]="selectedLanguage === language.code"
          [attr.data-cy]="'lang-' + language.code + '-selector'"
        ></i>
        <span class="lang-label tw-text-[#000000]">{{ language.label }}</span>
      </button>
    }
  </div>

</section>
